import { ACTION_TYPES, Actions } from "../actions/types"
import { stateHandler } from "./handler"
import { InitialState } from "./types"

const INITIAL_STATE : InitialState = {
    name: "",
    locationIds: [],
    locations: [],
    id: "",
    listing: [],
    isError: false,
    fetchSuccess: false,
    errorMessage: ""
}
export const reducer = (state = INITIAL_STATE, action: Actions) => {
    const handler = stateHandler(state)
    
    switch (action.type) {
    case ACTION_TYPES.FETCH_LISTING:
        return {...state}
    case ACTION_TYPES.FETCH_LISTING_SUCCESS:
        return handler.fetchListingSuccess(action.payload)
    case ACTION_TYPES.SET_NAME:
        return handler.setName(action.payload)
    case ACTION_TYPES.SET_LOCATION_IDS:
        return handler.setLocationIds(action.payload)
    case ACTION_TYPES.SUBMIT_SUCCESS:
        return handler.submitSuccess()
    case ACTION_TYPES.SUBMIT_FAIL:
        return handler.submitFail(action.payload)
    case ACTION_TYPES.CLEAR_LOCATION: 
        return handler.clearLocation()
    case ACTION_TYPES.SET_FROM_LISTING:
        return handler.setFromListing(action.payload)
    case ACTION_TYPES.DELETE_SUCCESS:
        return handler.deleteSuccess()
    case ACTION_TYPES.DELETE_FAIL:
        return handler.deleteFail(action.payload)
    case ACTION_TYPES.SET_INVENTORY_LOCATION:
        return handler.setInventoryLocation(action.payload)
    default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/location/reducers/reducer.ts